/**
 * Step navigation and guided validation helpers for the report builder.
 */
const STEP_ICON_MAP = {
  basics: "bi-sliders",
  scope: "bi-bullseye",
  data_selection: "bi-ui-checks-grid",
  columns: "bi-layout-text-window-reverse",
  review: "bi-file-earmark-check",
};

const STEP_COMPLETION_CHECKS = {
  basics: (component) =>
    Boolean(component.selected_report_type_id && component.selected_output_format_id),
  scope: (component) => component.is_scope_step_complete(),
  data_selection: (component) => component.is_data_step_complete(),
  columns: (component) => Boolean(component.selected_field_ids.length),
  review: (component) => Boolean(component.generated_report),
};

const STEP_VALIDATORS = {
  scope: (component) => component.validate_scope_step(),
  data_selection: (component) => component.validate_data_selection_step(),
  columns: (component) => component.validate_columns_step(),
};

const resolve_validation_message = (component, message) => {
  if (!message) {
    return true;
  }
  component.show_error(message);
  return false;
};

export default {
  initialize_builder_view_mode() {
    this.builder_view_mode = "guided";
  },
  set_builder_view_mode(mode) {
    this.builder_view_mode = mode;
  },
  handle_step_header_click(step_key) {
    if (!this.is_advanced_mode) {
      this.open_step(step_key);
    }
  },
  open_step(step_key) {
    this.current_step_key = step_key;
  },
  is_step_active(step_key) {
    return this.current_step_key === step_key;
  },
  is_step_visible(step_key) {
    return this.is_advanced_mode || this.is_step_active(step_key);
  },
  get_step_icon(step_key) {
    const icon = Reflect.get(STEP_ICON_MAP, step_key) || "bi-folder";
    return icon;
  },
  get_step_status(step_key) {
    if (this.is_step_active(step_key)) {
      return "active";
    }
    return this.is_step_complete(step_key) ? "complete" : "upcoming";
  },
  is_step_complete(step_key) {
    const checker = Reflect.get(STEP_COMPLETION_CHECKS, step_key);
    const status = checker ? checker(this) : false;
    return status;
  },
  is_scope_step_complete() {
    const message = this.get_scope_validation_message();
    return !message;
  },
  is_data_step_complete() {
    if (!this.is_question_scope_report || !this.is_question_statistics_summary) {
      return true;
    }
    return this.selected_questions.length > 0;
  },
  validate_scope_step() {
    const message = this.get_scope_validation_message();
    return resolve_validation_message(this, message);
  },
  validate_data_selection_step() {
    if (!this.is_question_statistics_summary) {
      return true;
    }
    if (!this.selected_questions.length) {
      this.show_error("Please select at least one question.");
      return false;
    }
    return this.validate_question_metrics();
  },
  validate_columns_step() {
    const message = this.get_columns_validation_message();
    return resolve_validation_message(this, message);
  },
  validate_current_step() {
    const validator = Reflect.get(STEP_VALIDATORS, this.current_step_key);
    return validator ? validator(this) : true;
  },
  go_to_previous_step() {
    if (this.previous_step_key) {
      this.current_step_key = this.previous_step_key;
    }
  },
  go_to_next_step() {
    if (!this.next_step_key) {
      return;
    }
    if (!this.validate_current_step()) {
      return;
    }
    this.current_step_key = this.next_step_key;
  },
};
